import React, { useCallback } from "react";
import { CameraProvider } from "./CameraContext.tsx";
import CameraCore from "./CameraCore.tsx";
import { DeviceSelector, ScanControls, ErrorDisplay } from "./CameraControls.tsx";
import { ScanResult } from "hooks/useCameraScanner.ts";
import { useScanListener } from "hooks/useScanListener.ts";
import "./QRScanner.css";

export interface QRScannerProps {
  onScan?: (result: ScanResult) => void;
  className?: string;
  videoClassName?: string;
  overlayContent?: React.ReactNode;
}

const QRScannerContent: React.FC<QRScannerProps> = ({
  onScan,
  className = "",
  videoClassName = "",
  overlayContent,
}) => {
  // Use the scan listener hook to forward scans to the onScan prop
  useScanListener(useCallback((result: ScanResult) => {
    onScan?.(result);
  }, [onScan]));

  return (
    <div className={`qr-scanner ${className}`}>
      <div className="qr-scanner__container">
        <CameraCore
          className="qr-scanner__camera"
          videoClassName={videoClassName}
        >
          {overlayContent}
        </CameraCore>
      </div>

      <div className="qr-scanner__controls">
        <DeviceSelector className="qr-scanner__device-selector" />
        <ScanControls className="qr-scanner__scan-controls" />
        <ErrorDisplay className="qr-scanner__error" />
      </div>
    </div>
  );
};

const QRScanner: React.FC<QRScannerProps> = (props) => {
  return (
    <CameraProvider autoStart>
      <QRScannerContent {...props} />
    </CameraProvider>
  );
};

export default QRScanner; 